import React, { useState } from "react";
import { Typography } from "@mui/material";
import { SaveFilterModalStyled } from "./save-filter-modal.styles";
import TextInputField from "../../form-fields/text-input-field/text-input-field";

const SaveFilterModal = ({ show, onClose, onSave, filters = [] }) => {
  // Local state to manage the filter name input and any error messages.
  const [filterName, setFilterName] = useState("");
  const [globalError, setGlobalError] = useState("");

  // Called when the user clicks the confirm (Save) button.
  const handleSave = () => {
    const trimmedName = filterName.trim();
    if (!trimmedName) {
      setGlobalError("Filter name cannot be empty.");
      return;
    }
    if (trimmedName.toLowerCase() === "default") {
      setGlobalError('You cannot use "Default" as the filter name.');
      return;
    }

    // If valid, call the external save handler.
    onSave(trimmedName);
    // Reset the input and error state.
    setFilterName("");
    setGlobalError("");
  };

  // Do not render the modal if show is false.
  if (!show) return null;

  return (
    <SaveFilterModalStyled
      confirmBtnTitle="Save"
      confirmBtnColor="#77E250"
      closeBtnTitle="Cancel"
      disableConfirmBtn={!filterName.trim()}
      onConfirm={handleSave}
      onClose={() => {
        // Reset state on close.
        setFilterName("");
        setGlobalError("");
        onClose();
      }}
    >
      <div>
        <div className="head">
          <Typography variant="h4">Save as Filter</Typography>
        </div>
        <div className="form">
          {globalError && <p className="error-text">{globalError}</p>}
          <div className="form-group">
            <TextInputField
              value={filterName}
              onChange={(e) => {
                setFilterName(e.target.value);
                if (globalError) setGlobalError(""); // clear error on change
              }}
              label="Filter Name*"
              placeholder="Enter filter name"
              sx={{ width: "100%" }}
            />
          </div>
          {/* <div className="filters-summary">
            <Typography variant="subtitle1">Filters to be saved:</Typography>
            {filters && filters.length > 0 ? (
              filters.map((filter, i) => (
                <Typography key={i} variant="body2">
                  {filter.titleName}: {filter.value}
                </Typography>
              ))
            ) : (
              <Typography variant="body2">No filters selected.</Typography>
            )}
          </div> */}
        </div>
      </div>
    </SaveFilterModalStyled>
  );
};

export default SaveFilterModal;
